<template>
  <div class="box-layout" style="background-color: #e6f0fb; max-width: 450px">
    <div class="phone-graphic">
      <div class="phone-container-outer">
        <div class="phone-container-inner">
          <div class="phone-header">
            <p class="phone-header-time">1:02</p>
            <p class="phone-header-icons">
              <span class="material-icons">signal_cellular_alt</span>
              <span class="material-icons">wifi</span>
              <span class="material-icons battery">battery_std</span>
            </p>
            <div class="contact-phone">
              <div>
                <img
                  src="/static/img/assets/welcome/ArrowBackwhite.svg"
                  class="depa-icon"
                  style="border-radius: 100%; width: 16px; height: 16px"
                />
              </div>
              <div>
                <img
                  src="/static/img/assets/welcome/OfficialLine.svg"
                  class="depa-icon"
                  style="border-radius: 100%; width: 16px; height: 16px"
                />
                depaThailand
              </div>
              <div>
                <img
                  src="/static/img/assets/welcome/Homewhite.svg"
                  class="depa-icon"
                  style="border-radius: 100%; width: 16px; height: 16px"
                />
                <img
                  src="/static/img/assets/welcome/ArrowDownwhite.svg"
                  class="depa-icon"
                  style="border-radius: 100%; width: 16px; height: 16px"
                />
              </div>
            </div>
          </div>

          <div
            class="phone-messages"
            :class="answers[intent_index].length == 0 ? 'noScroll' : ''"
            style="overflow-y: scroll; padding-bottom: 80px"
          >
            <template v-if="answers[intent_index].length > 0">
              <div
                v-for="(message, index) in answers[intent_index]"
                :key="'answer_message_' + index"
                :id="'answer_message_' + index"
                style="margin-bottom: 5px"
              >
                <template v-if="message.type === 'text'">
                  <div style="display: flex; flex-direction: row; gap: 20px">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%; width: 32px; height: 32px"
                      />
                    </div>
                    <div class="message message-contact-text" style="padding: 13px">
                      <div>
                        <typography :label="message.text" :color="color - darkGrey"></typography>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="message.type === 'button'">
                  <div style="display: flex; flex-direction: row; gap: 20px">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%; width: 32px; height: 32px"
                      />
                    </div>
                    <div class="message message-contact" style="padding: 13px">
                      <div style="display: flex; flex-direction: column; gap: 10px">
                        <typography h6 :label="message.text" color="color - darkGrey"></typography>
                        <template v-for="(button, index) in message.buttons">
                          <div class="button-editButton">
                            <typography :label="button.title" bold color="color-white"></typography>
                          </div>
                          <div>
                            <span
                              style="cursor: pointer; display: flex; justify-content: center"
                              v-clipboard:copy="button.title"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onCopyError"
                            >
                              {{ button.url || button.payload }}
                            </span>
                            <hr />
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="message.type === 'image'">
                  <div style="display: flex; flex-direction: row; gap: 20px">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%; width: 32px; height: 32px"
                      />
                    </div>
                    <div>
                      <image-type :value="message.image_url" :align="align"></image-type>
                    </div>
                  </div>
                </template>
                <template v-else-if="message.type == 'generic'">
                  <div style="display: flex; flex-direction: column">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%; width: 32px; height: 32px"
                      />
                    </div>
                    <div
                      class="generic-container"
                      style="
                        display: flex;
                        flex-direction: row;
                        overflow-x: auto;
                        padding-bottom: 16px;
                      "
                    >
                      <template v-for="(data, index) in message.data">
                        <div class="generic-Card">
                          <div style="width: 100%">
                            <div
                              :style="{
                                height:
                                  (size == 'big' ? '216' : '216') /
                                    (ratio == 'horizontal' ? 1.91 : 1) +
                                  'px',
                                'background-image': 'url(\'' + data.image_url + '\')',
                              }"
                              style="
                                width: 241px;
                                height: 216px;
                                background-size: cover;
                                background-position: center;
                                background-repeat: no-repeat;
                                border-top-right-radius: 15px;
                                border-top-left-radius: 15px;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                              margin-top: 4px;
                              width: 100%;
                              padding: 10px;
                            "
                          >
                            <div
                              style="
                                width: 220px;
                                margin-bottom: 6px;
                                font-weight: 700;
                                font-size: 16px;
                                color: #252525;
                              "
                            >
                              {{ data.title }}
                            </div>
                            <div
                              style="
                                width: 220px;
                                margin-bottom: 6px;
                                margin-top: 14px;
                                font-weight: 500;
                                font-size: 16px;
                                color: #252525;
                              "
                            >
                              {{ data.subtitle }}
                            </div>
                            <div
                              style="
                                display: flex;
                                flex-direction: column;
                                gap: 10px;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <div
                                style="
                                  width: 100%;
                                  gap: 10px;
                                  display: flex;
                                  flex-direction: column;
                                "
                                v-if="data.buttons.length > 0"
                              >
                                <template v-for="(item, idx) in data.buttons">
                                  <div class="button-editButton">
                                    <typography
                                      :label="item.title"
                                      bold
                                      color="color-white"
                                    ></typography>
                                  </div>
                                  <div>
                                    <span
                                      style="
                                        cursor: pointer;
                                        display: flex;
                                        justify-content: center;
                                      "
                                      v-clipboard:copy="item.title"
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onCopyError"
                                    >
                                      {{ item.url || item.payload }}
                                    </span>
                                    <hr />
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- <generic-viewer
                  v-model="message.data"
                  :size="size"
                  :align="align"
                  :ratio="message.ratio"
                ></generic-viewer> -->
                </template>
                <template v-else-if="message.type == 'flex'">
                  <div style="display: flex; flex-direction: column">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%; width: 32px; height: 32px"
                      />
                    </div>
                    <div
                      class="text-xs-center pa-2"
                      style="border: 1px solid #eee; border-radius: 10px"
                      :style="{ float: align }"
                    >
                      <vue-simple-svg
                        :filepath="'/static/img/assets/get_started/add-menu_list.svg'"
                        width="40px"
                        height="40px"
                        class="img"
                        :fill="$vuetify.theme.primary"
                      />
                      <div class="primary--text caption">Line Flex Message</div>
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </template>
                <template v-else-if="message.type === 'sticker'">
                  <div style="display: flex; flex-direction: column">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%; width: 32px; height: 32px"
                      />
                    </div>
                    <div style="max-width: 200px; padding-left: 20px">
                      <v-img
                        aspect-ratio="1"
                        :src="`/static/img/assets/stickers/${message.packageid}/${message.stickerid}.png`"
                        :lazy-src="`/static/img/assets/stickers/${message.packageid}/${message.stickerid}.png`"
                        style="width: 100%"
                      >
                        <template v-slot:placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-layout>
                        </template>
                      </v-img>
                    </div>
                  </div>
                </template>
                <template v-else-if="message.type == 'video'">
                  <div style="display: flex; flex-direction: row; gap: 20px">
                    <div>
                      <img
                        src="/static/img/assets/welcome/depaIcon.svg"
                        class="depa-icon"
                        style="border-radius: 100%; width: 32px; height: 32px"
                      />
                    </div>
                    <div>
                      <div v-if="message.source">
                        <div v-if="message.source.indexOf('//api') != -1">
                          <video width="100%" controls style="border-radius: 16px">
                            <source :src="message.source" type="video/mp4" />
                          </video>
                        </div>
                        <div v-else-if="message.source.indexOf('youtube') != -1">
                          <LazyYoutube maxWidth="720px" :src="message.source" />
                        </div>
                      </div>
                      <div v-else-if="message.sourceline">
                        <div v-if="message.sourceline.indexOf('//api') != -1">
                          <video width="100%" controls style="border-radius: 16px">
                            <source :src="message.sourceline" type="video/mp4" />
                          </video>
                        </div>
                        <div v-else-if="message.sourceline.indexOf('youtube') != -1">
                          <LazyYoutube maxWidth="720px" :src="message.sourceline" />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="clearfix"></div>
              </div>
              <div style="display: flex; overflow-x: scroll; gap: 7px">
                <div v-for="(choice, index) in choices" :key="'choice' + index">
                  <span
                    style="
                      margin-bottom: 7px;
                      display: flex;
                      border: 1px solid #0c2f53;
                      background-color: #e6f0fb;
                      border-radius: 25px;
                      padding: 5px 10px;
                      white-space: nowrap;
                    "
                  >
                    <typography h6 :color="color - darkBlue" :label="choice.text" />
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 100%;
                "
              >
                <img
                  src="/static/img/assets/welcome/empty-chatboxMessage.svg"
                  style="width: 80px; height: 80px; margin-bottom: 24px"
                />
                <typography h3 bold7 :label="$t('ไม่มีข้อความตอบกลับ')" :bold="true"></typography>
                <typography
                  h6
                  bold5
                  :label="$t('กรุณาคลิกโมดูลด้านขวามือเพื่อเพิ่มลงในตัวอย่าง')"
                  :medium="true"
                ></typography>
              </div>
            </template>
          </div>
          <div class="phone-footer">
            <div class="phone-footer-icons"><span class="material-icons">photo_camera</span></div>
            <div class="phone-footer-input">
              <p>Text Message</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Copied') }}!</v-snackbar
    >
  </div>
</template>
<script>
import Typography from './Typography.vue'
import ImageType from './ImageType'
import Template from '../view/template/template.vue'
import { LazyYoutube } from 'vue-lazytube'

export default {
  props: ['intent_index', 'answers', 'choices'],
  components: {
    Typography,
    ImageType,
    Template,
    LazyYoutube,
  },
  mounted: function () {
    console.log('ANSWER PREVIEW', this.answers, this.intent_index)
  },
}
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 16px;
}
.box-layout {
  width: 100%;
}
.text-error {
  color: red;
}
.text-area-focus {
  border: 1px solid #0c2f53;
  border-radius: 6px;
}
.box-title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 6px;
}
.button-inputButtonType {
  height: 37px;
  width: 300px;
  background: #ffffff;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  padding-left: 14px;
  padding-right: 14px;
  color: #0c2f53;
  outline: none;
  box-shadow: none !important;
}
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tooltiptext {
  visibility: hidden;
  width: 270px;
  background-color: rgba(238, 238, 238, 1);

  color: rgba(12, 47, 83, 1);
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  right: -250px;
  top: -50px;
  /* left: 100; */
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
.message {
  word-break: break-word;
}
.modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 30px 26px 30px 26px;
  position: fixed;
  top: 40px;
  overflow-x: hidden;
  border-radius: 10px;
  background-color: #fff;
}
.btn-footer {
  display: flex;
  flex-direction: row;
  gap: 14px;
}
.btn-summit {
  background: #0c2f53 !important;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #ffef01;
  font-weight: 700;
  font-size: 16px;
}
.btn-cancel {
  background: #ffffff !important;
  border: 1px solid #0c2f53;
  border-radius: 6px;
  width: 142px;
  height: 38px;
  color: #0c2f53;
  font-weight: 700;
  font-size: 16px;
}
.button-editButton {
  background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
  border-radius: 5px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
}
.generic-Card {
  width: 241px;
  min-height: 363px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  padding-bottom: 10px;
  margin-right: 20px;
  /* margin-left: 30px; */
  background: #ffffff;
  border: 1px solid #eeeeee;
  box-shadow: 4px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
}
/* PHONE CONTAINERS */
.phone-graphic {
  position: relative;
  width: 330px;
  margin: auto;
  margin-top: 30px;
  margin-bottom: 30px;
}
.phone-container-outer {
  position: relative;
  /* font-family: helvetica; */
  font-size: 0.8rem;
  border: 1px solid #8f8f8f;
  border-radius: 40px;
  box-shadow: inset 1px 1px 10px #ddd, inset 1px 1px 3px #8f8f8f, 0 0 6px #1059a5;
  background-color: #000;
}
.phone-container-inner {
  position: relative;
  background: #fff;
  margin: 13px;
  border-radius: 30px;
  overflow: hidden;
}

.phone-container-inner:before {
  content: '';
  position: absolute;
  top: 0;
  background-color: #000;
  width: 110px;
  height: 17px;
  left: calc(50% - 55px);
  border-radius: 0 0 20px 20px;
  z-index: 2;
}
.phone-header {
  position: absolute;
  width: 100%;
  height: 60px;
  top: 0;
  background-color: rgba(48, 62, 87, 1);
}

/* HEADER ICONS AND TIME */
.phone-header-time {
  position: absolute;
  font-size: 0.8rem;
  top: 5px;
  left: 15px;
}
.phone-header-icons {
  position: absolute;
  top: 5px;
  right: 15px;
}
.phone-header-icons .material-icons {
  font-size: 0.9rem;
}
.phone-header-icons .material-icons.battery {
  transform: rotate(90deg);
}

/* CONTACT IMAGE AND NUMBER */
.contact-image {
  position: absolute;
  width: 34px;
  height: 34px;
  top: 30px;
  left: calc(50% - 17px);
  background-color: #b4b4ba;
  box-shadow: 0 0 0 3px #b4b4ba;
  border-radius: 100%;
  overflow: hidden;
}
.contact-image .material-icons {
  font-size: 2.8rem;
  color: #fff;
  margin-left: -5px;
}
.contact-phone {
  position: absolute;
  font-size: 0.62rem;
  top: 30px;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}
.contact-phone a {
  color: #000;
}

/* PHONE MESSAGES */
.phone-messages {
  margin-top: 60px;
  padding: 19px;
  height: 470px;
}

.noScroll {
  padding: 0px !important;
  padding-bottom: 80px !important;
  overflow: unset !important;
}
.message {
  padding: 5px 10px;
  margin-bottom: 10px;
  border-radius: 10px;
}
.message p {
  position: relative;
  z-index: 5;
  margin: 0;
}
.message-contact-text {
  position: relative;
  background-color: #eeeeee;
  /* background-color: red; */
  text-align: left;
}
.message-contact {
  position: relative;
  background-color: #eeeeee;
  /* background-color: red; */
  text-align: left;
  width: 100%;
}
.message-you {
  position: relative;
  background-color: #3bbe41;
  color: #fff;
  text-align: right;
  margin-left: 20%;
}
.message-contact:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: -10px;
  height: 0px;
  width: 0px;
  background: #eeeeee;
  /* background: green; */
  border-bottom-right-radius: 15px;
}
.message-contact:after {
  content: '';
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: -4px;
  width: 8px;
  height: 20px;
  background: #eeeeee;
  /* background: blue; */
  border-bottom-right-radius: 20px;
  rotate: 100deg;
  top: 0px;
}

.message-you:before {
  content: '';
  position: absolute;
  bottom: 0;
  right: -10px;
  height: 20px;
  width: 20px;
  background: #3bbe41;
  border-bottom-left-radius: 15px;
}
.message-you:after {
  content: '';
  position: absolute;
  z-index: 1;
  bottom: 0;
  right: -15px;
  width: 15px;
  height: 20px;
  background: white;
  border-bottom-left-radius: 20px;
}

/* PHONE FOOTER */
.phone-footer {
  position: absolute;
  height: 40px;
  bottom: 0;
  width: 100%;
  background-color: #efefef;
}
.phone-footer-icons {
  position: absolute;
  bottom: 3px;
  left: 15px;
  color: #7b838d;
}
.phone-footer-input {
  position: absolute;
  bottom: 7px;
  left: 50px;
  width: 200px;
  border: 1px solid #cfcfd2;
  padding: 3px 10px;
  border-radius: 30px;
}
.phone-footer-input p {
  margin: 0;
  color: #cfcfd2;
}
.tag-box {
  background-color: #fff;
  padding: 0px 8px 0px 8px;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px dotted rgba(189, 189, 189, 1);
  color: rgba(189, 189, 189, 1);
  border-radius: 6px;
  min-width: 60px;
  text-align: center;
  height: 25px;
}

.input-box {
  height: 20px !important;
  border-bottom: none !important;
  font-family: 'Sukhumvit' !important;
}
.input-box:focus {
  border-bottom: none !important;
  box-shadow: none !important;
}
.tag-box-edit {
  background-color: #fff;
  padding: 0px 8px 0px 8px;
  display: inline-block;
  margin-right: 8px;
  /* margin-bottom: 8px; */
  border: 1px dotted rgba(189, 189, 189, 1);
  color: black;
  border-radius: 6px;
  min-width: 60px;
  text-align: center;
  height: 25px;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #0c2f53;
  border-radius: 10px;
  background-clip: padding-box;
  border: 3px solid transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/PreviewDeviceScreen.vue